<template>
  <el-form ref="form" :model="form" :disabled="disabled">
    <h3 class="blue-text">{{title}}</h3>
    <div class="row">
      <div class="col-md-4 col-12">
        <el-form-item
          :label="L10n('customer')"
          prop="customerCompanyID"
          :rules="getValidationRule('required')"
          class="material-style"
        >
          <select-company
            :model.sync="form.customerCompanyID"
            :disabled="!showButton && disabled"
            @on-created="mixCreateCustomer"
            @on-change="(id) => mixChangeCustomerID(id)"
          >
          </select-company>
        </el-form-item>
      </div>
      <div class="col-md-4 col-12">
        <el-form-item
          :label="L10n('customer-detail')"
          prop="customerCompanyDetailID"
          class="material-style">
          <select-company-detail
            withAutoSelect
            :model.sync="form.customerCompanyDetailID"
            :companyID="form.customerCompanyID"
            @on-change="autoSave('customerCompanyDetailID')"
            :disabled="disabled"
          ></select-company-detail>
        </el-form-item>
      </div>
      <div class="col-md-4 col-12">
        <el-form-item
          :label="L10n('customer-contact')"
          prop="customerContactID"
          :rules="getValidationRule('required')"
          class="material-style">
          <select-company-contact
            :model.sync="form.customerContactID"
            :companyID="form.customerCompanyID"
            @on-change="autoSave('customerContactID')"
            :disabled="disabled"
          ></select-company-contact>
        </el-form-item>
      </div>
    </div>
    <div class="row">
      <div class="col-xl-3 col-md-6 col-12">
        <el-form-item
          :label="L10n('rfq-type')"
          prop="rfqTypeID"
          class="material-style"
          :rules="getValidationRule('required')"
        >
          <select-response
            :model.sync="form.rfqTypeID"
            @on-change="autoSave('rfqTypeID', { required: true })"
            :isLoading="dataSourceRfqType.loading"
            :data="dataSourceRfqType.records"
          ></select-response>
        </el-form-item>
      </div>
      <div class="col-xl-3 col-md-6 col-12">
        <el-form-item
          :label="L10n('employee')"
          :rules="getValidationRule('required')"
          prop="baxEmployeeID"
          class="material-style"
        >
          <select-response
            :model.sync="form.baxEmployeeID"
            @on-change="autoSave('baxEmployeeID', { required: true })"
            :fields="{ id: 'id', title: 'name'}"
            :isLoading="dataSourceEmployee.loading"
            :data="dataSourceEmployee.records"
            :disabled="disabled || disabledEmployee"
          ></select-response>
        </el-form-item>
      </div>
      <div class="col-xl-3 col-md-6 col-12">
        <el-form-item
          :label="L10n('priority')"
          :rules="getValidationRule('required')"
          prop="priorityID"
          class="material-style">
          <select-response
            :model.sync="form.priorityID"
            @on-change="autoSave('priorityID', { required: true })"
            :isLoading="dataSourcePriority.loading"
            :data="dataSourcePriority.records"
          ></select-response>
        </el-form-item>
      </div>
      <div class="col-xl-3 col-md-6 col-12">
        <el-form-item
          :label="L10n('observation')"
          prop="observation"
          class="material-style">
          <el-input
            v-model="form.observation"
            @change="autoSave('observation', { required: true })"
          ></el-input>
        </el-form-item>
      </div>
    </div>
    <button-line
      v-if="showButton"
      @click="createRFQ"
    >
      {{L10n('create-rfq')}}
    </button-line>
  </el-form>
</template>

<script>
import { mixUpdateCustomer } from '@/mixins/companies'
import Form from '@/components/Form/Form'
import { waitValue } from '@/utils/promises'
export default {
  name: 'RFQMainRFQ',
  mixins: [Form, mixUpdateCustomer],
  components: {
    'button-line': () => import(/* webpackChunkName: 'UI' */ '@/components/UI/ButtonLine.vue'),
    'select-company': () => import(/* webpackChunkName: 'Shared' */ '@/components/Shared/SelectCompany/Index.vue'),
    'select-company-contact': () => import(/* webpackChunkName: 'Shared' */ '@/components/Shared/SelectCompanyContact/Index.vue'),
    'select-company-detail': () => import(/* webpackChunkName: 'Shared' */ '@/components/Shared/SelectCompanyDetail/Index.vue')
  },
  props: {
    disabledEmployee: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    title: { type: String },
    moduleName: { type: String, required: true },
    showButton: { type: Boolean, default: true },
    isValid: { type: Boolean }
  },
  watch: {
    form: {
      immediate: true,
      handler () {
        waitValue(() => (this.$refs['form']))
          .then((form) => {
            form.validate((isValid) => {
              this.$emit('update:isValid', isValid)
              form.clearValidate()
            })
          })
      }
    }
  },
  computed: {
    dataSourceRfqType () {
      return this.API('RFQTypes/GetAllDynamic?select=id,title')
    },
    dataSourceEmployee () {
      return this.API('Employees/GetAllDynamic?select=id,name&filter=isActive==true')
    },
    dataSourcePriority () {
      return this.API('Priorities/GetAllDynamic?select=id,title&orderBy=title')
    }
  },
  methods: {
    createRFQ () {
      this.$refs.form.validate()
        .then(() => {
          return this.$store.dispatch(`${this.moduleName}/createRFQ`, { ...this.form })
            .then(() => {
              this.$emit('command', 'created-rfq')
            })
            .catch((err) => {
              this.requestErrorHandler(err)
            })
        })
    }
  }
}
</script>
